
export const clienti_da_richiamare = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Clienti da richiamare',
        name: 'RichiamaEntro',
    },
]

export const alert_scaduti = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Alert scaduti',
        name: 'AlertScaduti',
    },
]

export const alert_in_scadenza = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Alert in scadenza',
        name: 'AlertScadenza',
    },
]

export const nuovo_cliente = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Nuovo cliente',
        name: 'NuovoCliente',
    },
]

export const lista_clienti = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Clienti e contatti',
        name: 'ListaClienti',
    },
]

export const lista_fornitori = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Fornitori',
        name: 'ListaFornitori',
    },
]


export const contatti = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Anagrafica',
        name: 'DettaglioAzienda',
    },
    {
        title: 'Contatti',
        name: 'Contatti',
    },
]

export const nuovo_contatto = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Anagrafica',
        name: 'DettaglioAzienda',
    },
    {
        title: 'Contatti',
        name: 'Contatti',
    },
    {
        title: 'Nuovo contatto',
        name: 'FormContatto',
    },
]


export const progetti = [
    {
        title: 'Home',
        name: 'Dashboard',
    },
    {
        title: 'Anagrafica',
        name: 'DettaglioAzienda',
    },
    {
        title: 'Progetti',
        name: 'Progetti',
    },
]


export const dettaglio_progetto = [
    {
        title: 'Progetti',
        name: 'ListaProgetti',
    },
    {
        title: 'Dettaglio progetto',
        name: 'DettaglioProgetto',
    },
]

export const nuovo_fornitore = [
    {
        title: 'Fornitori',
        name: 'ListaFornitori',
    },
    {
        title: 'Nuovo fornitore',
        name: 'NuovoFornitore',
    },
]

export const dettaglio_fornitore = [
    {
        title: 'Fornitori',
        name: 'ListaFornitori',
    },
    {
        title: 'Dettaglio fornitore',
        name: 'DettaglioFornitore',
    },
]

export const dettaglio_sottoprogetto = [
    {
        title: 'Progetti',
        name: 'ListaProgetti',
    },
    {
        title: 'Sottoprogetti',
        name: 'ListaSottoProgetti',
    },
    {
        title: 'Dettaglio sottoprogetto',
        name: 'DettaglioSottoProgetto',
    },
]
